const initState = {
    showModal: ''
};

export default function modal(state = initState, { type } = {}) {
    return { ...state, showModal: type };
}
